// src/sections/productEngraving.js
var productEngraving = () => {
  const resetFontClass = (element) => {
    element.classList.remove("font--gilroy");
    element.classList.remove("font--avenir");
    element.classList.remove("font--bentham");
    element.classList.remove("font--cutivemono");
    element.classList.remove("font--moonflower");
  };
  const getCurrentImage = (form) => {
    let frontside = true;
    if (form.classList.contains("engraving--backside"))
      frontside = false;
    let image = false;
    if (frontside) {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-frontside"
      );
    } else {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-backside"
      );
    }
    return image;
  };
  const handleFontInput = (form, inputFonts, inputText) => {
    inputFonts.forEach((input) => {
      input.addEventListener("change", (event) => {
        event.preventDefault();
        resetFontClass(inputText);
        inputText.classList.add(input.dataset.font);
        const image = getCurrentImage(form);
        if (image) {
          const imageTextelement = image.querySelector(".engrave-text p");
          resetFontClass(imageTextelement);
          imageTextelement.classList.add(input.dataset.font);
        }
      });
    });
  };
  const updateImage = (image, text) => {
    const textElement = image.querySelector(".engrave-text p");
    if (textElement)
      textElement.innerHTML = text;
  };
  const handleTextInput = (form, input) => {
    const image = getCurrentImage(form);
    input.addEventListener("input", () => {
      if (image)
        updateImage(image, input.value);
    });
  };
  const addIcon = (input, icon) => {
    const maxLength = input.maxLength ? input.maxLength : 1;
    if (input.value.length >= maxLength) {
      alert("Max length of engraving reached");
    } else {
      input.value += icon;
      const inputEvent = new Event("input", {
        bubbles: true,
        cancelable: true
      });
      input.dispatchEvent(inputEvent);
    }
  };
  const handleIconInput = (form, iconContainer, input) => {
    if (!iconContainer)
      return false;
    const buttons = iconContainer.querySelectorAll("button");
    buttons.forEach((button) => {
      console.log(button);
      button.addEventListener("click", (event) => {
        event.preventDefault();
        console.log("click");
        const type = button.dataset.icon;
        let icon = "";
        switch (type) {
          case "star-icon":
            icon = "\u2605";
            break;
          case "heart-icon":
            icon = "\u2665";
            break;
          default:
            icon = "";
        }
        addIcon(input, icon);
      });
    });
  };
  const initForm = (form) => {
    const inputFonts = form.querySelectorAll('input[type="radio"]');
    const inputSelector = form.querySelector("#engraving-text");
    const inputText = inputSelector || form.querySelector("#engraving-text-backside");
    const iconContainer = form.querySelector(".engraving-icon-selector") ? form.querySelector(".engraving-icon-selector") : "";
    handleFontInput(form, inputFonts, inputText);
    handleTextInput(form, inputText);
    handleIconInput(form, iconContainer, inputText);
  };
  const productEngraving2 = () => {
    const forms = document.querySelectorAll(".variant.engraving");
    if (forms.length > 0) {
      forms.forEach((form) => initForm(form));
    }
  };
  productEngraving2();
};
export {
  productEngraving
};
